import { Action, Dispatch } from "redux";
import api from "../../api";

export interface SetEurocodeExceptionsAction extends Action {
    type: "SET_EUROCODE_EXCEPTIONS";
    exceptions: EurocodeException[];
}

export interface AddEurocodeExceptionAction extends Action {
    type: "ADD_EUROCODE_EXCEPTION";
    exception: EurocodeException;
}

export interface UpdateEurocodeExceptionAction extends Action {
    type: "UPDATE_EUROCODE_EXCEPTION";
    exception: EurocodeException;
}

export interface DeleteEurocodeExceptionAction extends Action {
    type: "DELETE_EUROCODE_EXCEPTION";
    id: string;
}

export type Actions =
    | SetEurocodeExceptionsAction
    | AddEurocodeExceptionAction
    | UpdateEurocodeExceptionAction
    | DeleteEurocodeExceptionAction;

// Internal dispatch-only actions (used by thunks)
const _setEurocodeExceptions = (exceptions: EurocodeException[]): SetEurocodeExceptionsAction => ({
    type: "SET_EUROCODE_EXCEPTIONS",
    exceptions
});

const _addEurocodeException = (exception: EurocodeException): AddEurocodeExceptionAction => ({
    type: "ADD_EUROCODE_EXCEPTION",
    exception
});

const _updateEurocodeException = (exception: EurocodeException): UpdateEurocodeExceptionAction => ({
    type: "UPDATE_EUROCODE_EXCEPTION",
    exception
});

const _deleteEurocodeException = (id: string): DeleteEurocodeExceptionAction => ({
    type: "DELETE_EUROCODE_EXCEPTION",
    id
});

// Thunks
export const loadEurocodeExceptions = () => async (dispatch: Dispatch<any>) => {
    const exceptions = await api.EurocodeExceptionApi.getAll();
    dispatch(_setEurocodeExceptions(exceptions));
};

export const saveEurocodeException = (exception: EurocodeException) => async (dispatch: Dispatch<any>) => {
    const isNew = exception.id.startsWith("new_");
    const payload = isNew
        ? { ...exception, id: "00000000-0000-0000-0000-000000000000" }
        : exception;
    const saved = await api.EurocodeExceptionApi.createOrUpdate(payload);
    if (isNew) {
        dispatch(_addEurocodeException(saved));
        dispatch(_deleteEurocodeException(exception.id));
    } else {
        dispatch(_updateEurocodeException(saved));
    }
};

export const removeEurocodeException = (id: string) => async (dispatch: Dispatch<any>) => {
    await api.EurocodeExceptionApi.delete(id);
    dispatch(_deleteEurocodeException(id));
};

export const updateEurocodeExceptionLocal = (exception: EurocodeException): UpdateEurocodeExceptionAction =>
    _updateEurocodeException(exception);

export const addEurocodeExceptionOptimistic = (exception: EurocodeException): AddEurocodeExceptionAction =>
    _addEurocodeException(exception);

export const deleteEurocodeExceptionOptimistic = (id: string): DeleteEurocodeExceptionAction =>
    _deleteEurocodeException(id);

